import { useEffect, useState } from 'react';

const GOOGLE_API_KEY = 'AIzaSyA0D0bdyi0mLXh2caELffJghKatcpoAjsg';
const GOOGLE_CLIENT_ID = '571887393269-22fjvnevo0imu1loq2cs2fkl8ufrbvth.apps.googleusercontent.com';
const GOOGLE_APP_ID = '571887393269';

export function useGooglePicker(onFilePicked, options = {}) {
  const [pickerLoaded, setPickerLoaded] = useState(false);
  const [loadError, setLoadError] = useState(null);
  const { getAccessToken, onAccessToken } = options;

  useEffect(() => {
    if (window.gapi) {
      window.gapi.load('picker', () => setPickerLoaded(true));
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/api.js';
    script.onload = () => {
      window.gapi.load('picker', () => setPickerLoaded(true));
    };
    script.onerror = () => setLoadError('Failed to load Google API');
    document.head.appendChild(script);
  }, []);

  const requestPickerToken = () => {
    if (!window.google?.accounts?.oauth2) {
      setLoadError('Failed to load Google Identity Services');
      return;
    }

    const tokenClient = window.google.accounts.oauth2.initTokenClient({
      client_id: GOOGLE_CLIENT_ID,
      scope: 'https://www.googleapis.com/auth/drive.file',
      callback: (tokenResponse) => {
        if (tokenResponse.error || !tokenResponse.access_token) {
          alert('Failed to get Google access token');
          return;
        }

        onAccessToken?.(tokenResponse.access_token);
        openPicker(tokenResponse.access_token);
      }
    });

    // Use 'select_account' to open a proper popup (avoiding the hidden-iframe
    // overlay from prompt:'') without forcing re-consent on every open.
    tokenClient.requestAccessToken({ prompt: 'select_account' });
  };

  const showPicker = () => {
    if (!pickerLoaded) {
      alert('Google Picker still loading');
      return;
    }

    // getAccessToken must be synchronous here — any await breaks the browser's
    // user-gesture context, causing the GIS popup to open behind the page.
    const existingToken = getAccessToken?.();
    if (existingToken) {
      openPicker(existingToken);
      return;
    }

    requestPickerToken();
  };

  const openPicker = (accessToken) => {
    const view = new window.google.picker.DocsView(
      window.google.picker.ViewId.DOCS
    )
      .setIncludeFolders(true)
      .setMimeTypes('application/vnd.google-apps.document');

    const picker = new window.google.picker.PickerBuilder()
      .setAppId(GOOGLE_APP_ID)
      .setDeveloperKey(GOOGLE_API_KEY)
      .setOAuthToken(accessToken)
      .addView(view)
      .setCallback((data) => {
        if (data.action === window.google.picker.Action.PICKED) {
          const doc = data.docs[0];
          onFilePicked(
            `https://docs.google.com/document/d/${doc.id}`,
            doc.id,
            accessToken
          );
        }
      })
      .build();

    picker.setVisible(true);
  };

  return { showPicker, pickerLoaded, loadError };
}
